import { useLocation } from 'react-router-dom';

import MessagePage from '../../components/MessagePage';
import type { PrivateOutletProps } from './PrivateOutlet';
import PrivateOutlet from './PrivateOutlet';
import type { IState } from './types/State';

export const RequestOutlet = (props: PrivateOutletProps): JSX.Element => {
  const location = useLocation();

  const { state: currentState } = location;
  if (!currentState || !(currentState as IState).continue) {
    return <MessagePage message="You can close this window now." />;
  }

  return <PrivateOutlet {...props} />;
};

export default RequestOutlet;
